import UserSimple from "@/models/user/UserSimple";
import {EmploymentType, Gender} from "@/helpers/constants";
import Address from "@/models/address/Address";
import IBlamable from "@/models/IBlamable";
import UserBlamable from "@/models/user/UserBlamable";

export default class User extends UserSimple implements IBlamable {

	public username!: string;
	public gender!: Gender;
	public birthday!: string | null;
	public notes!: string | null;

	public timeZone!: string;
	public languageCode!: string;
	public countryCode!: string;
	public employmentType!: EmploymentType | null;

	public address!: Address;

	public hasReports!: boolean;

	public createdAt!: string | null;
	public createdBy!: UserBlamable | null;
	public updatedAt!: string | null;
	public updatedBy!: UserBlamable | null;

}
